// extracted by mini-css-extract-plugin
module.exports = {"button":"AppNewsActions_button__3z8pu","menuIcon":"AppNewsActions_menuIcon__1Lg0T","openButton":"AppNewsActions_openButton__1DWMZ"};